var map = {
	"./ENFJ.svg": 11,
	"./ENFP.svg": 12,
	"./ENTJ.svg": 13,
	"./ENTP.svg": 14,
	"./ESFJ.svg": 15,
	"./ESFP.svg": 16,
	"./ESTJ.svg": 17,
	"./ESTP.svg": 18,
	"./INFJ.svg": 19,
	"./INFP.svg": 20,
	"./INTJ.svg": 21,
	"./INTP.svg": 22,
	"./ISFJ.svg": 23,
	"./ISFP.svg": 24,
	"./ISTJ.svg": 25,
	"./ISTP.svg": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;